"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetReferenceMarkdownDirectiveDefinition = void 0;
exports.formatNetReferenceDirective = formatNetReferenceDirective;
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.NetReferenceMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['netName'],
    contentAttributeName: 'netName',
    directive: 'net',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
    editorMarker: '#',
});
function formatNetReferenceDirective(netName) {
    return `:${exports.NetReferenceMarkdownDirectiveDefinition.directive}[${(0, MarkdownDirectiveDefinition_1.escapeDirectiveContent)(netName)}]`;
}
//# sourceMappingURL=NetReference.js.map